<template lang="pug">
  .component-reveal-void
    ModalReveal
      button.button.danger(slot="trigger") Registration token
      .row
        .column
          label Registration tokens
            select(v-model="body.registrationToken")
              option(v-for="(token) in registrationTokens" :value="token.id") RT{{token.id}} {{token.token}}
        .column
          .label Type
          .field-value(v-if="selected !== null") {{selected.destination_type}} {{selected.destination_id}}
          .label Additional
          template(v-if="selected !== null" )
            .field-value(v-if="selected !== null" v-for="additional in selected.additional" ) {{additional.class}} {{additional.id}}
      ActionButton(slot="footer" :action="add") Add
      button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Cancel

</template>
<script type="text/babel">
import ModalReveal from '../../../foundation/ModalReveal'
import InputSwitch from '../../InputSwitch'
import ActionButton from '../../ActionButton'
import Transaction from '../../../../backoffice/Transaction'
import BaseList from '../../../../../pages/backoffice/BaseList'
import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";
import MaggieHelper from "../../../../../maggieHelper";

export default {
  name: 'ApplyRegistrationTokenReveal',
  components: {BaseList, Transaction, ActionButton, InputSwitch, ModalReveal},
  data() {
    return {
      registrationTokens: [],
      body: {
        registrationToken: null
      }
    }
  },
  created() {
    KeplerBackofficeSdk.registrationTokens.list(1, -1).all((data) => {
      this.registrationTokens = data.items
    })
  },

  methods: {
    add() {
      return KeplerBackofficeSdk.registrationTokens.select(this.selected.id).apply(this.item.id, () => {
        MaggieHelper.notification('Token','Token applied')
      })
    }
  },
  computed: {
    selected() {
      const id = this.registrationTokens.findIndex((i) => i.id === this.body.registrationToken)
      return id !== -1 ? this.registrationTokens[id] : null
    },
    componentId() {
      return `reveal-${this.item.id}`
    }
  },
  props: ['item'],
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-reveal-void
  .modal-footer
    .footer
      display: flex
      justify-content: space-around
</style>



// WEBPACK FOOTER //
// ApplyRegistrationTokenReveal.vue?9d22bbc4